import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ClinicMasterProduct } from '../../../../apis/clinic-master-products/types';
import { StyledPaperContainer } from '../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { StyledButtonsContainer } from '../../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ClinicProduct } from '../../../../apis/clinic-products/types';
import CreateClinicMasterProduct from '../Buttons/CreateClinicMasterProduct';

interface ClinicMasterProductFooterProps {
  form: UseFormReturn<ClinicMasterProduct>;
  productsForm: UseFormReturn<ClinicProduct[]>;
}

export const CreateClinicMasterProductFooter = ({ productsForm, form }: ClinicMasterProductFooterProps) => {
  return (
    <StyledPaperContainer>
      <StyledButtonsContainer>
        <CreateClinicMasterProduct productsForm={productsForm} form={form} />
      </StyledButtonsContainer>
    </StyledPaperContainer>
  );
};
